"use client"
import React, {createContext, ReactNode, useEffect, useState} from "react";
import logger from "@/app/logger";
import {getSocket} from "@/websocket-client";

interface SocketContextType {
  connected: boolean;
}

export const SocketContext = createContext<SocketContextType | null>(null);

export function SocketConnectionManager({children}: {children: ReactNode}) {
  const socket = getSocket()
  const [connected, setConnected] = useState(false)
  useEffect(() => {
    if (!socket) {
      return
    }
    function onConnect() {
      setConnected(true)
      logger.debug("Socket: onConnect");
    }

    if (socket.connected) {
      onConnect();
    }

    function onDisconnect() {
      setConnected(false)
      logger.debug("Socket: onDisconnect");
    }

    logger.debug("Connecting socket");
    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    return () => {
      logger.debug("Disconnecting socket");
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  }, [socket]);
  return <SocketContext.Provider value={{connected}}>
    {children}
  </SocketContext.Provider>
}